import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import { getSurveyDisplayName } from "../../Utils/surveyDisplayName";
import { Confirmation } from "../../Shared/Confirmation";
import moment from "moment";
import { isPanelCountryByName } from './surveyConstants';

type State = {
  survey: any,
  status: string,
  error: string | null,
};


class Details extends React.Component<any, State> {
  // Hey! sonarqube, Please ignore this code
  // static defaultProps = {
  //   languageId: null,
  //   hideMenu: false,
  //   onUpdate: () => null,
  // };

  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      survey: null,
      status: PageStatus.None,
      error: null,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.id) {
      this.fetchSurvey();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchSurvey() {
    Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }) })
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SurveysAPI.getOne(this.props.id);
      })
      .then((respoData) => {
        if (this._isMounted && respoData) {
          let survey = respoData.data;
          this.setState({ survey, status: PageStatus.Loaded });
        }
      })
      .catch((error) => {
        if (this._isMounted) this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  onDelete() {
    Promise.resolve()
      .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }) })
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SurveysAPI.deleteOne(this.props.id);
      })
      .then((country) => {
        if (this._isMounted) {
            this.setState({ status: PageStatus.Loaded });
            return this.props.onDelete()
        }
      })
      .catch((error) => {
        if (this._isMounted) this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  render() {
    const sendSurveyTpByValue = (): string => {
      let exArray: string[] = [];
      if (this.state.survey?.sms === "Y") exArray.push("SMS");
      if (this.state.survey?.whatsapp === "Y") exArray.push("Whats-App");
      if (this.state.survey?.email === "Y") exArray.push("Email");
      return exArray.join(", ");
    }
    const showSurveysTpStatus = (type) => {
      let obj = {
        "Open": "Live",
        "Hold": "On Hold",
        "Wait": "Ids Awaited",
        "Close": "End",
        "Test": "Test",
        "Error": "Error",
      };
      return obj[type] ?? "";
    }
    const setYNinRespoField = (cond) => { if (cond) { return "Yes" } return "No"; }
    return (
      <>
      <Modal
        centered
        size="lg"
        backdrop="static"
        onHide={this.props.onClose}
        show
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <h5 className="mb-0 mt-1">Details</h5>
          <div
            className="d-flex justify-content-end w-100 mr-2"
          >
            {this.props.role !== 'sales' && (
              <button
                type="button"
                onClick={() => this.props.onUpdate()}
                className="btn-sm btn-primary mr-2"
              >
                <FontAwesomeIcon
                  icon={['fas', 'edit']}
                  className="mr-2"
                />
                Update
              </button>
            )}
            {/* Bug 6: delete icon removed from Survey details panel.
                Deletion is handled exclusively via the left-sidebar
                "Deletion of Projects" tab. onDelete handler retained
                for potential programmatic callers. */}
          </div>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded && !!this.state.survey}>
            {(() => {
              const survey = this.state.survey;
              // parentid === null → this is the project-level parent survey
              const isParent = !survey?.parentid;
              // Panel-only fields are shown only for child surveys in panel countries
              const showPanelFields = !isParent && isPanelCountryByName(survey?.country);
              return (
                <>
                  {/* ── Always visible ── */}
                  {survey?.parentid && isPanelCountryByName(survey?.country) && (
                    <div className="row mt-2">
                      <div className="col">
                        <strong>SMS/WhatsApp Name: </strong>
                        {survey?.name}
                      </div>
                      <div className="col" />
                    </div>
                  )}

                  {survey?.parentid && (
                    <div className="row mt-2">
                      <div className="col">
                        <strong>Parent Id: </strong>
                        {survey?.parentid}
                      </div>
                      <div className="col" />
                    </div>
                  )}

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Project Name: </strong>
                      {getSurveyDisplayName(survey)}
                    </div>
                    <div className="col">
                      <strong>Project Id: </strong>
                      {survey?.projectId}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Survey UUID: </strong>
                      {survey?.id}
                    </div>
                    <div className="col">
                      <strong>Start-End IP Validated: </strong>
                      {setYNinRespoField(survey?.validateStartEndIp === "Y")}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Country Validated: </strong>
                      {setYNinRespoField(survey?.validateCountry === "Y")}
                    </div>
                    <div className="col">
                      <strong>Country: </strong>
                      {survey?.country ?? "N.A."}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Description: </strong>
                      {survey?.description}
                    </div>
                    <div className="col">
                      <strong>Survey Length: </strong>
                      {survey?.surveyLength}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Start Date: </strong>
                      {moment(survey?.createdAt).format('MM/DD/YYYY HH:mm A')}
                    </div>
                    <div className="col">
                      <strong>End Date: </strong>
                      {moment(survey?.expiryDate).format('MM/DD/YYYY HH:mm A')}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Client Quota: </strong>
                      {survey?.userLimitCommitted}
                    </div>
                    <div className="col">
                      <strong>Client: </strong>
                      {survey?.client}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Survey Status: </strong>
                      {showSurveysTpStatus(survey?.surveyType)}
                    </div>
                    <div className="col">
                      <strong>PM Name: </strong>
                      {survey?.pmName}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Speeder Limit (In minutes): </strong>
                      {survey?.outlierCutoffTime}
                    </div>
                    <div className="col">
                      <strong>Cost Per Interview: </strong>
                      {survey?.currency ?? ""}
                      {survey?.costPerInterview}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>IP Unique: </strong>
                      {setYNinRespoField(survey?.ipUnique)}
                    </div>
                    <div className="col">
                      <strong>Survey URL Identifier: </strong>
                      {survey?.surveyUrlIdentifier}
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <strong>Client IR: </strong>
                      {survey?.clientir ?? "N.A."}
                    </div>
                    <div className="col">
                    </div>
                  </div>

                  {/* ── Child only (both panel and non-panel) ── */}
                  {!isParent && (
                    <>
                      <div className="row mt-2">
                        <div className="col">
                          <strong>Test URL: </strong>
                          <a href={survey?.testurl} target="_blank" rel="noopener noreferrer">
                            {survey?.testurl}
                          </a>
                        </div>
                        <div className="col">
                          <strong>Live URL: </strong>
                          <a href={survey?.url} target="_blank" rel="noopener noreferrer">
                            {survey?.url}
                          </a>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col">
                          <strong>Use Unique Links: </strong>
                          {setYNinRespoField(survey?.useUniqueLinks)}
                        </div>
                        <div className="col" />
                      </div>
                    </>
                  )}

                  {/* ── Panel children only ── */}
                  {showPanelFields && (
                    <>
                      <div className="row mt-2">
                        <div className="col">
                          <strong>Complete Points: </strong>
                          {survey?.ceggPoints}
                        </div>
                        <div className="col">
                          <strong>Over Quota Points: </strong>
                          {survey?.overquota}
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col">
                          <strong>Terminate Points: </strong>
                          {survey?.terminate}
                        </div>
                        <div className="col">
                          <strong>Quality Terminate Points: </strong>
                          {survey?.qualityterminate}
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col">
                          <strong>Point Allocation Type: </strong>
                          {survey?.pointAllocationType}
                        </div>
                        <div className="col">
                          <strong>DX Quota: </strong>
                          {survey?.userLimitCutoff}
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col">
                          <strong>Send Survey By: </strong>
                          {sendSurveyTpByValue()}
                        </div>
                        <div className="col" />
                      </div>

                      <div className="row mt-2">
                        <div className="col">
                          <strong>Disclaimer: </strong>
                          <span dangerouslySetInnerHTML={{ __html: survey?.disclaimer || 'Title' }} />
                        </div>
                      </div>
                    </>
                  )}
                </>
              );
            })()}
            <Alert
              variant="danger"
              show={this.state.status === PageStatus.Error}
            >
              {this.state.error}
            </Alert>
          </Show>
        </Modal.Body>
      </Modal>
      </>
    );
  }
}

const DetailsWithRouter = withRouter(Details);

export { DetailsWithRouter as Details };
